import {
  OPEN_GROUP,
  CLOSE_GROUP,
  GET_AUTOCOMPLETE4,
  GET_MOREAUTOCOMPLETE4,
  GET_AUTOCOMPLETE5,
  GET_MOREAUTOCOMPLETE5,
  GET_GROUPTYPES,
  OPEN_GROUPREGISTRATIONFEE,
  GET_TRAININGSTATUS
} from '../actions/types'

export default function groupsReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_GROUP:
      return {...state, thisgroup: action.group}
    case CLOSE_GROUP:
      delete state.thisgroup
      delete state.groupregistrationfee
      return {...state}
      //return {...state, thisperson: false}
    case GET_AUTOCOMPLETE4:
      return {...state, autocomplete: action.payload}
    case GET_MOREAUTOCOMPLETE4:
      return {
        ...state,
        autocomplete2: state.message.concat(action.payload)
      }
    case GET_AUTOCOMPLETE5:
      return {...state, autocomplete: action.payload}
    case GET_MOREAUTOCOMPLETE5:
      return {
        ...state,
        autocomplete2: state.message.concat(action.payload)
      }
    case GET_GROUPTYPES:
      return {...state, grouptypes: action.grouptypes}
    case OPEN_GROUPREGISTRATIONFEE:
      return {...state, groupregistrationfee: action.groupregistrationfee}
    case GET_TRAININGSTATUS:
      return {...state, trainingstatus: action.trainingstatus}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/groups_reducer.js